// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { modalButtonsActionStyles, xScreen } from "@awc/XDL/Utilities";
import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

shareListModalStyles.recipientEmailTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
            position: absolute;
        `,
    },
    typographyProps: {
        weight: "normal",
    },
    iconProps: {
        css: css`
            margin-left: 6px;
            margin-top: 3px;
        `,
    },
};

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipContainer: css`
            width: 500px;
            ${xScreen("lte", "sm")} {
                width: 290px;
            }
        `,
        tooltipBody: css`
            padding: 5px;
        `,
    },
    typographyProps: {
        lineHeight: "16px",
    },
    iconProps: {
        css: css`
            margin-left: 6px;
        `,
    },
};

shareListModalStyles.buttonsContainer = {
    gap: 10,
    css: css`
        & ${GridOffset} {
            justify-content: flex-end;
            & > ${GridItemStyle} {
                flex-basis: auto;
                max-width: fit-content;
            }
        }
    `,
};

shareListModalStyles.shareByEmailRadio = {
    css: css`
        height: 19px;
        & + & {
            margin-top: 0 !important;
            margin-left: 20px;
            ${xScreen("lte", "xs")} {
                margin-left: 0;
            }
        }
        input {
            margin-left: 0;
        }
    `,
};

shareListModalStyles.shareListOptionRadioGroup = shareListModalStyles.shareByOptionRadioGroup = {
    css: css`
        flex-direction: row;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;
                        gap: 10px;
                    `,
                ],
                "max",
            )}
    `,
};

shareListModalStyles.sendCopyRadio = shareListModalStyles.shareByEmailRadio;

shareListModalStyles.container = { gap: 15 };

shareListModalStyles.sendButton = modalButtonsActionStyles.submitButton;

shareListModalStyles.cancelButton = modalButtonsActionStyles.cancelButton;

shareListModalStyles.yourNameGridItem = shareListModalStyles.recipientEmailAddressGridItem = { width: 12 };

shareListModalStyles.allowEditingGridItem = {
    width: 8,
    css: css`
        &&& {
            margin-right: auto;
        }
    `,
};

shareListModalStyles.sendButtonGridItem = shareListModalStyles.cancelButtonGridItem = { width: 2 };
shareListModalStyles.shareByEmailTooltip = shareListModalStyles.shareByBillingTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
    },
    iconProps: {
        css: css`
            margin-left: 6px;
        `,
    },
};
shareListModalStyles.shareListOptionGridItem = shareListModalStyles.shareByOptionGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        gap: 5px;
    `,
};
